import { registerBackendActions } from './backend.actions';
import { registerDialogActions } from './dialog.actions';
import { registerViewStateActions } from './view-state.actions';
import type { ActionRegistryImpl } from './action-registry';

/**
 * Registers all application actions with the given registry.
 *
 * Called explicitly from actions/index.ts (side-effect import in main.ts)
 * after DI setup and bootstrap, BEFORE router initialization.
 * Uses explicit registration instead of decorator-based side-effects
 * (@CommandHandler pattern) to avoid fragile import-order dependencies.
 *
 * @param registry - The ActionRegistryImpl to register all actions with.
 */
export function registerActions(registry: ActionRegistryImpl): void {
    registerViewStateActions(registry);
    registerDialogActions(registry);
    registerBackendActions(registry);
}
